import PageTemplate from '../components/common/PageTemplate';
import ConsultationHistory from '../screen/telemedicine/ConsultationHistory';

const ConsultationHistoryPage = () => {
  return (
    <PageTemplate
      mainComponent={<ConsultationHistory />}
      noPadding={true}
      logo={"Riwayat Konsultasi"}
    />
  );
}

export default ConsultationHistoryPage
